import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  PrestacaoContasDetailsState,
  PrestacaoContasDetailsAction,
  PrestacaoContasDetailsReducer,
} from './prestacao-contas-details-reducer';

const initialState: PrestacaoContasDetailsState = {
  prestacaoContasDetails: null,
  loading: false,
  error: null,
};

const PrestacaoContasDetailsStateContext = createContext<PrestacaoContasDetailsState | undefined>(undefined);
const PrestacaoContasDetailsDispatchContext = createContext<React.Dispatch<PrestacaoContasDetailsAction> | undefined>(undefined);

interface PrestacaoContasDetailsProviderProps {
  children: ReactNode;
}

export const PrestacaoContasDetailsProvider: React.FC<PrestacaoContasDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(PrestacaoContasDetailsReducer, initialState);

  return (
    <PrestacaoContasDetailsStateContext.Provider value={state}>
      <PrestacaoContasDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </PrestacaoContasDetailsDispatchContext.Provider>
    </PrestacaoContasDetailsStateContext.Provider>
  );
};

export const usePrestacaoContasDetailsState = (): PrestacaoContasDetailsState => {
  const context = useContext(PrestacaoContasDetailsStateContext);
  if (context === undefined) {
    throw new Error('usePrestacaoContasDetailsState must be used within a PrestacaoContasDetailsProvider');
  }
  return context;
};

export const usePrestacaoContasDetailsDispatch = (): React.Dispatch<PrestacaoContasDetailsAction> => {
  const context = useContext(PrestacaoContasDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('usePrestacaoContasDetailsDispatch must be used within a PrestacaoContasDetailsProvider');
  }
  return context;
};
